import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiConfigService {

	constructor() { }

	getApiUrl(): string {
		return environment.apiUrl;
	}

	getFullUrl(endpoint: string): string {
		// Remove leading slash if present to avoid double slashes
		const cleanEndpoint: string = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
		return `${this.getApiUrl()}/${cleanEndpoint}`;
	}
}



// WEBPACK FOOTER //
// ./src/app/core/api-config.service.ts